export function ThumbsDownIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <path
        id='Icon_feather-thumbs-down'
        data-name='Icon feather-thumbs-down'
        d='M10.6,17.5A2.934,2.934,0,0,1,7.645,14.59V12.409H4.21a2.224,2.224,0,0,1-1.691-.75A2.157,2.157,0,0,1,2,9.9L3.019,3.353a2.173,2.173,0,0,1,.755-1.334A2.233,2.233,0,0,1,5.229,1.5H15.512a2.432,2.432,0,0,1,2.457,2.084.718.718,0,0,1,.007.1V8.772a.717.717,0,0,1-.007.1,2.432,2.432,0,0,1-2.456,2.084H14.028l-2.757,6.113A.738.738,0,0,1,10.6,17.5Zm-6.39-6.545H8.383a.733.733,0,0,1,.738.727V14.59a1.46,1.46,0,0,0,1.027,1.386l2.662-5.9V2.954h-7.6a.738.738,0,0,0-.73.618L3.46,10.119a.718.718,0,0,0,.173.585.741.741,0,0,0,.565.25ZM14.286,9.5h1.263a.963.963,0,0,0,.951-.783V3.737a.963.963,0,0,0-.968-.783H14.286Z'
        transform='translate(-1.976 -1.499)'
        fill='currentColor'
      />
    </svg>
  )
}
